<template>
  <el-form-item label="是否提交集团公司审核" v-if="!isCurrentCompany">
    <el-radio v-model="isSubmitApproval" :label="1" @change="handleData">是</el-radio>
    <el-radio v-model="isSubmitApproval" :label="0" @change="handleData">否</el-radio>
  </el-form-item>
</template>
<script>
export default {
  name: 'approvalRadio',
  data() {
    return {
      isSubmitApproval: 0
    }
  },
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    modelValue: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: String | Array | Number
    }
  },
  watch: {
    modelValue(val) {
      this.isSubmitApproval = val
    },
  },
  methods: {
    handleData() {
      this.$emit('change', this.isSubmitApproval)
    }
  },
  computed: {
    isCurrentCompany() {
      // 判断登录是否为当前总公司
      return JSON.parse(this.$base.getLocalStorage('current_company')).companyName === process.env.VUE_APP_COMPANY_NAME
    }
  }
}
</script>